import { Stack, Card, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { Scrollbar } from '../scrollbar';
import { CustomAvatar } from '../custom-avatar';
import { Strings } from '@app/constants';
import { StatusTag } from '../status-tag';

interface SubCardProps {
  name: string;
  from?: string;
  to?: string;
  managers?: string;
  priority?: string;
  date?: string;
  user: {
    firstName?: string;
    lastName?: string;
  };
  approvedUser: {
    firstName?: string;
    lastName?: string;
  };
  periods: Array<{ date: string; period: string }>;
}

const SubCard = ({
  name,
  from,
  to,
  managers,
  priority,
  date,
  approvedUser,
  user,
  periods,
}: SubCardProps) => {
  const theme = useTheme();
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const approvedUserName = `${approvedUser?.firstName} ${approvedUser?.lastName}`;
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const userName = `${user?.firstName} ${user?.lastName}`;

  return (
    <Card sx={{ borderRadius: '5px', margin: 1, m: 1.5, height: 'auto' }}>
      <Stack justifyContent={'space-between'} direction={'row'} m={0.5}>
        <Stack direction="row" spacing={1} alignItems="center">
          <CustomAvatar name={user ? userName : name} color="info" />
          <Stack>
            <Stack> {user ? userName : name}</Stack>
            <Stack direction={'row'} gap={0.5}>
              <Stack fontSize={10} color={theme.palette.grey[600]}>
                {user ? `${from ?? ''} to ${to ?? ''}` : `${Strings.projects.managedBy}:`}
              </Stack>
              <Stack fontSize={10}>{managers ?? ''}</Stack>
            </Stack>
          </Stack>
        </Stack>
        <Stack>
          <Stack mr={2} color={theme.palette.grey[600]} fontSize={12} textAlign={'end'}>
            {approvedUser
              ? Strings.dashboard.approvedBy
              : periods?.length && `${periods?.length} days`}
          </Stack>

          {approvedUser ? (
            <Stack mr={2} fontSize={12} fontWeight={600} direction={'row'}>
              <Typography>
                <CustomAvatar
                  sx={{ mr: 0.5, fontSize: 10, height: 22, width: 22 }}
                  name={approvedUserName}
                  color="info"
                />
              </Typography>
              <Typography variant="body2"> {approvedUserName}</Typography>
            </Stack>
          ) : (
            <Stack
              mr={2}
              fontSize={12}
              fontWeight={600}
              mt={priority && 1}
              justifyContent={'center'}
            >
              {priority ? <StatusTag status={priority ?? ''} /> : date}
            </Stack>
          )}
        </Stack>
      </Stack>
    </Card>
  );
};

interface MainCardProps {
  title?: string;
  subCards?: any;
  height?: string | number;
  scrollBarHeight?: number;
}

const LeaveCard = ({ title, subCards, height, scrollBarHeight }: MainCardProps) => {
  return (
    <Card
      sx={{ height, width: { md: '100%', sm: '90%' }, borderRadius: '5px', overflow: 'hidden' }}
    >
      {title && (
        <Typography
          fontWeight={700}
          fontSize={17}
          sx={{
            paddingLeft: 2,
            marginTop: 1,
          }}
        >
          {title}
        </Typography>
      )}

      <Scrollbar sx={{ height: scrollBarHeight }}>
        {subCards?.map((subCard: any, index: any) => (
          <SubCard key={index} {...subCard} />
        ))}
      </Scrollbar>
    </Card>
  );
};

export { LeaveCard };
